import Bridge from './Bridge'

BS.DOMReady(() => {
	[].forEach.call(document.querySelectorAll('.js-index-edit-replace'), el => {
		// オプションを読み込む
		const optionDiv = el.parentNode
		const optionJson = optionDiv.getAttribute('data-index-edit-options')
		const options = optionJson ? JSON.parse(optionJson) : null

		new Bridge(el, options)
	})
})

// const Sortable = BS.Editor.getPlugin("sortablejs");
